import { Div, MultilineInput } from "@tblabs/truffle";
import { Order } from "../../../../../../Models/Order";


export class OrderNotesEdit extends Div
{
    constructor(order: Order)
    {
        super();

        this.Append(
            new Div("tab-content__title").Text("Notatka klienta"),
            new MultilineInput(order.Notes.Customer).Rows(6).Placeholder("Ten tekst nie będzie widoczny dla klienta choć został przez niego napisany"),
            new Div("tab-content__title").Text("Notatka prywatna"),
            new MultilineInput(order.Notes.Private).Rows(6).Placeholder("Ten tekst nie będzie widoczny dla klienta"),
            new Div("tab-content__title").Text("Notatka publiczna").MarginTop(16),
            new MultilineInput(order.Notes.Public).Rows(6).Placeholder("Ten tekst będzie widoczny dla klienta!")
        );
    }
}
